/* src/app/components/admin/login-tracker/login-tracker.component.scss */
:host-context(.dark-theme) .mat-mdc-card {
  background-color: #2c2c2c;
}
/*# sourceMappingURL=login-tracker.component.css.map */
